import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { MatFormField, MatLabel, MatInput, MatHint, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
@Component({
    selector: 'app-form-textarea',
    templateUrl: './form-textarea.component.html',
    styleUrls: ['./form-textarea.component.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatFormField, NgClass, MatLabel, MatInput, MatHint, MatError]
})
export class FormTextareaComponent implements Field, OnInit {
  config: FieldConfig;
  group: FormGroup;
  FormControlName: string;
  constructor() { }

  ngOnInit() {
    this.FormControlName = this.config.name;
    const remarkControl = this.group.controls['remark'] ?? this.group.controls['remarks'];
    if (remarkControl) {
      remarkControl.valueChanges.subscribe(value => {
        if (value?.length > this.config?.maxLengthCount) {
          remarkControl.setValue(value.substring(0, this.config.maxLengthCount), { emitEvent: false });
        }
      });
    }
  }

}
